import React from "react";
import { IntelligentDiscoveryHomeBlock } from "@twiliointernal/org/twilio/e2-commons/shared/definitions";
import NoMessageErrorsPresentHome from "./sub/NoMessageErrorsPresentHome";
import MessageErrorsPresentHome from "./sub/MessageErrorsPresentHome";

interface OnboardingProps {
  block: IntelligentDiscoveryHomeBlock;
}

const IntelligentDiscoveryAssistantHome: React.FC<OnboardingProps> = ({
  block,
}) => {
  const {
    values: { failedMessages, undeliveredMessages },
  } = block;
  const areMessagingErrorsPresent =
    failedMessages > 0 || undeliveredMessages > 0;

  return areMessagingErrorsPresent ? (
    <MessageErrorsPresentHome block={block} />
  ) : (
    <NoMessageErrorsPresentHome block={block} />
  );
};

export default IntelligentDiscoveryAssistantHome;
